import { FormatType } from '../Currency';

const UP_TRIANGLE = String.fromCharCode(8593);
const DOWN_TRIANGLE = String.fromCharCode(8595);

const getDirectionSymbol = (value: number, type?: FormatType): string | undefined => {
  if (type === 'gain' || (type === 'gain-loss' && value > 0)) {
    return UP_TRIANGLE;
  }

  if (type === 'loss' || (type === 'gain-loss' && value < 0)) {
    return DOWN_TRIANGLE;
  }

  return undefined;
};

export default getDirectionSymbol;
